module.exports = __webpack_public_path__ + "img/video_icon.c9c3f137.png";